import TimedSingle from './timedSingle'

export default TimedSingle
